import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "router/config";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./style/index.less";
import 'style/iconfont/iconfont.css';
import './filter';
import directive from './utils/directives.js';
import { TrackingBaiduURL } from 'api/common';

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(directive);

if(true) {
  TrackingBaiduURL();
}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
